import { c as _c } from "react/compiler-runtime";
import { IcoCheck16 } from '@onefootprint/icons';
import type { JSX } from 'react';
import Highlighter from 'react-highlight-words';
import type { CommonPropsAndClassName, GroupBase } from 'react-select';
import Text from '../../../../text';
import type { BaseSelectOption } from '../../base-select.types';
export type OptionProps<Option extends BaseSelectOption, IsMulti extends boolean = boolean, Group extends GroupBase<Option> = GroupBase<Option>> = CommonPropsAndClassName<Option, IsMulti, Group> & {
  innerProps: JSX.IntrinsicElements['div'];
  label: string;
  data: Option;
  isFocused: boolean;
  isSelected: boolean;
};
const Option = t0 => {
  const $ = _c(22);
  const {
    isSelected,
    selectProps,
    isFocused,
    innerProps,
    label,
    data
  } = t0;
  const {
    inputValue
  } = selectProps;
  let t1;
  if ($[0] !== inputValue) {
    t1 = [inputValue];
    $[0] = inputValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      background: "none",
      fontWeight: 600
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label || $[4] !== t1) {
    t3 = <Highlighter className="block truncate w-full" searchWords={t1} textToHighlight={label} highlightStyle={t2}>{label}</Highlighter>;
    $[3] = label;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== data.description) {
    t4 = data.description && <Text variant="caption-2" color="tertiary">{data.description}</Text>;
    $[6] = data.description;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex flex-col gap-0.5 items-start min-w-0 flex-1">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isSelected) {
    t6 = isSelected && <IcoCheck16 color="primary" />;
    $[11] = isSelected;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== innerProps.id || $[14] !== innerProps.onClick || $[15] !== innerProps.onMouseMove || $[16] !== innerProps.onMouseOver || $[17] !== innerProps.tabIndex || $[18] !== isFocused || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className="fp-dropdown-item text-body-2 absolute top-0 left-0 w-full flex items-center justify-between py-2 px-4 cursor-pointer" data-highlighted={isFocused} id={innerProps.id} onClick={innerProps.onClick} onMouseMove={innerProps.onMouseMove} onMouseOver={innerProps.onMouseOver} role="option" tabIndex={innerProps.tabIndex}>{t5}{t6}</div>;
    $[13] = innerProps.id;
    $[14] = innerProps.onClick;
    $[15] = innerProps.onMouseMove;
    $[16] = innerProps.onMouseOver;
    $[17] = innerProps.tabIndex;
    $[18] = isFocused;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default Option;